import { render, staticRenderFns } from "./DynamicContentModal.vue?vue&type=template&id=d56eeaee&scoped=true"
import script from "./DynamicContentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicContentModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicContentModal.vue?vue&type=style&index=0&id=d56eeaee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56eeaee",
  null
  
)

export default component.exports